export const stripPhone = (value = "") => String(value || "").trim().replace(/[^\d+]/g, "");

export const normalizeIndianPhone = (value = "") => {
  const raw = stripPhone(value);
  if (!raw) return "";

  if (raw.startsWith("+")) {
    return raw;
  }

  if (raw.startsWith("91") && raw.length === 12) {
    return `+${raw}`;
  }

  if (raw.length === 10) {
    return `+91${raw}`;
  }

  return raw;
};

export const formatPhoneDisplay = (value = "") => {
  const normalized = normalizeIndianPhone(value);
  if (!normalized) return "";

  if (/^\+91\d{10}$/.test(normalized)) {
    return `+91 ${normalized.slice(3, 8)} ${normalized.slice(8)}`;
  }

  return normalized;
};
